import { apis } from '@api/index';
import { format, formatDistance, subHours } from 'date-fns';
import { useEffect, useState } from 'react';
import { Button, Form, Input, Modal } from 'semantic-ui-react';
import { UserRestrictInfo } from 'src/types/user.types';

type Props = {
  type: 'ADD' | 'EDIT';
  isOpen: boolean;
  onClose: () => void;
  onSubmitEnd: () => Promise<void>;
  user: UserRestrictInfo | null;
};

const UserRestrictModal = ({
  type,
  isOpen,
  onClose,
  onSubmitEnd,
  user,
}: Props) => {
  const [userId, setUserId] = useState(user ? String(user.id) : '');
  const [reportBanEndDatetime, setReportBanEndDatetime] = useState<Date>(
    user?.reportBanEndDatetime
      ? new Date(user?.reportBanEndDatetime)
      : new Date(),
  );
  const [permanentBanStartTime, setPermanentBanStartTime] = useState<Date>(
    user?.permanentBanStartTime
      ? new Date(user?.permanentBanStartTime)
      : new Date(),
  );
  const [reason, setReason] = useState(user?.reason ?? '');

  useEffect(() => {
    setUserId(user ? String(user.id) : '');
    setReportBanEndDatetime(
      user?.reportBanEndDatetime
        ? new Date(user?.reportBanEndDatetime)
        : new Date(),
    );
    setPermanentBanStartTime(
      user?.permanentBanStartTime
        ? new Date(user?.permanentBanStartTime)
        : new Date(),
    );
    setReason(user?.reason ?? '');
  }, [user, isOpen]);

  const addRestrictUser = async () => {
    await apis.user.createOrUpdateUserRestrict({
      userId: Number(userId),
      reportBanEndDatetime: reportBanEndDatetime
        ? format(
            subHours(new Date(reportBanEndDatetime), 9),
            'yyyy-MM-dd HH:mm:ss',
          )
        : undefined,
      permanentBanStartTime: permanentBanStartTime
        ? format(
            subHours(new Date(permanentBanStartTime), 9),
            'yyyy-MM-dd HH:mm:ss',
          )
        : undefined,
      reason,
    });

    alert('유저 제한 정보 추가가 완료되었습니다.');
    onSubmitEnd();
    onClose();
  };

  const editRestrictUser = async () => {
    await apis.user.createOrUpdateUserRestrict({
      userId: Number(userId),
      reportBanEndDatetime: reportBanEndDatetime
        ? format(
            subHours(new Date(reportBanEndDatetime), 9),
            'yyyy-MM-dd HH:mm:ss',
          )
        : undefined,
      permanentBanStartTime: permanentBanStartTime
        ? format(
            subHours(new Date(permanentBanStartTime), 9),
            'yyyy-MM-dd HH:mm:ss',
          )
        : undefined,
      reason,
    });

    alert('유저 제한 정보 수정이 완료되었습니다.');
    onSubmitEnd();
    onClose();
  };

  return (
    <Modal size="small" open={isOpen} onClose={onClose}>
      <Modal.Header>유저 제한</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <label>user id</label>
            <Input
              name="id"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
          </Form.Field>
          <Form.Field>
            <label>신고금지 종료시점</label>
            <Input
              type="datetime-local"
              step="1"
              max="9999-12-31T23:59:59"
              value={format(reportBanEndDatetime, 'yyyy-MM-dd HH:mm:ss')}
              onChange={(e) =>
                setReportBanEndDatetime(new Date(e.target.value))
              }
            />
          </Form.Field>
          <Form.Field>
            <label>접속불가 시작시점</label>
            <Input
              type="datetime-local"
              step="1"
              max="9999-12-31T23:59:59"
              value={format(permanentBanStartTime, 'yyyy-MM-dd HH:mm:ss')}
              onChange={(e) =>
                setPermanentBanStartTime(new Date(e.target.value))
              }
            />
          </Form.Field>
          <Form.Field>
            <label>제한 사유</label>
            <Input value={reason} onChange={(e) => setReason(e.target.value)} />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="blue"
          content="제출"
          onClick={type === 'ADD' ? addRestrictUser : editRestrictUser}
        />
        <Button color="black" content="닫기" onClick={onClose} />
      </Modal.Actions>
    </Modal>
  );
};

export default UserRestrictModal;
